import React, { useState, useEffect } from "react";
import "./codingPlatform.css";
import { IoIosAddCircleOutline, IoMdCreate } from "react-icons/io";
import { fetchCodingProfiles, saveCodingProfile, deleteCodingProfile ,fetchTotalProblemsSolved} from "../../services/studentportalapis";

const CodingPlatform = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [error, setError] = useState("");
  const [form, setForm] = useState({
    platformName: "",
    platformUserId: "",
    problemsSolved: "",
    easy: "",
    medium: "",
    hard: "",
    customPlatformName: "",
  });
  const [platformsList, setPlatformsList] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null); // To track which platform is being edited
  const [totalProblems, setTotalProblems] = useState(0);

  // Fetch existing platforms on mount

  
  // useEffect(() => {
  //   const studentId = JSON.parse(localStorage.getItem('student-details'))['studentId'];
  //   if (studentId) {
  //     fetchCodingProfiles(studentId)
  //       .then((profiles) => setPlatformsList(profiles))
  //       .catch((error) => console.error("Error fetching profiles:", error));
  //   }
  // },[]);

  useEffect(() => {
  const studentId = JSON.parse(localStorage.getItem("student-details"))["studentId"];
  if (studentId) {
    fetchCodingProfiles(studentId)
      .then((profiles) => setPlatformsList(profiles))
      .catch((error) => console.error("Error fetching profiles:", error));

    fetchTotalProblemsSolved(studentId)
      .then((total) => setTotalProblems(total))
      .catch((error) => console.error("Error fetching total problems solved:", error));
  }
}, []);

  // Toggle Popup
  const togglePopup = () => setIsPopupOpen(!isPopupOpen);

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Automatically calculate total problems for LeetCode and GeeksForGeeks
    if (["easy", "medium", "hard"].includes(name)) {
      const updatedForm = { ...form, [name]: value };
      updatedForm.problemsSolved =
        (parseInt(updatedForm.easy || 0) +
          parseInt(updatedForm.medium || 0) +
          parseInt(updatedForm.hard || 0)) ||
        "";
      setForm(updatedForm);
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  // Add or Edit platform data
  const handleAddOrEditPlatform = (e) => {
    e.preventDefault();

    if (editingIndex === null) {
      if (
        !form.platformName ||
        !form.platformUserId ||
        (!form.problemsSolved && form.platformName !== "Other")
      ) {
        alert("Please fill in all fields before adding.");
        return;
      }

      // Check if the platform already exists when adding
      const platformExists = platformsList.some(
        (platform) =>
          platform.platformName === form.platformName &&
          platform.platformUserId === form.platformUserId
      );

      if (platformExists) {
        setError("This platform already exists.");
        return;
      }
    }

    const platformData = {
      platformName:
        form.platformName === "Other" ? form.customPlatformName : form.platformName,
      platformUserId: form.platformUserId,
      problemsSolved: form.problemsSolved,
      lastEdited: new Date().toISOString(),
      studentId: JSON.parse(localStorage.getItem("student-details"))["studentId"],
    };

    if (editingIndex !== null) {
      // Edit the platform data
      const updatedPlatforms = [...platformsList];
      updatedPlatforms[editingIndex] = platformData;
      setPlatformsList(updatedPlatforms);
      setEditingIndex(null); // Reset editing state

      // Make API call to update
      saveCodingProfile(platformData)
      .then((updatedProfile) => {
        setForm({
          platformName: "",
          platformUserId: "",
          problemsSolved: "",
          easy: "",
          medium: "",
          hard: "",
          customPlatformName: "",
        });
        togglePopup(); // Close the popup after updating

        const studentId = JSON.parse(localStorage.getItem("student-details"))["studentId"];
        fetchTotalProblemsSolved(studentId)
          .then((total) => setTotalProblems(total))
          .catch((error) => console.error("Error fetching total problems solved:", error));
      })
      .catch((error) => console.error("Error updating platform:", error));
    } else {
      // Add a new platform
      saveCodingProfile(platformData)
        .then((newProfile) => {
          setPlatformsList([...platformsList, newProfile]);
          setForm({
            platformName: "",
            platformUserId: "",
            problemsSolved: "",
            easy: "",
            medium: "",
            hard: "",
            customPlatformName: "",
          });
          togglePopup(); // Close the popup after adding
        })
        .catch((error) => console.error("Error adding platform:", error));
    }
  };


  // Handle delete platform
  const handleDeletePlatform = (profileId) => {
    deleteCodingProfile(profileId)
      .then(() => {
        setPlatformsList(platformsList.filter((profile) => profile.id !== profileId));
      })
      .catch((error) => console.error("Error deleting platform:", error));
  };

  // Handle Edit
  const handleEdit = (index) => {
    const platformToEdit = platformsList[index];

     // Check if it is a custom platform
  const isCustom = !["LeetCode", "GeeksForGeeks", "HackerRank"].includes(platformToEdit.platformName);

    console.log("Editing platform:", platformToEdit); // Inspect platform data
    setForm({
        platformName: isCustom ? "Other" : platformToEdit.platformName,
    // customPlatformName: isCustom ? platformToEdit.platformName : "", //here - changes custom platform name 
      platformUserId: platformToEdit.platformUserId,
      problemsSolved: platformToEdit.problemsSolved || "",
      easy: platformToEdit.easy || "",
      medium: platformToEdit.medium || "",
      hard: platformToEdit.hard || "",
      customPlatformName: isCustom ? platformToEdit.platformName : "",
    });
    console.log("Updated form state:", form); // Inspect updated form state
    setEditingIndex(index);
    togglePopup();
  };

  const handleAdd = (index) => {
    setForm({
      platformName: "",
      platformUserId: "",
      problemsSolved: "",
      easy: "",
      medium: "",
      hard: "",
      customPlatformName: "",
    });
    togglePopup();
  };



  return (
    <div className="coding-platform-container">
      {/* Add Platform Button */}

      <div className="w-full text-xl font-semibold text-blue-900 mb-4">
        Total Problems Solved: {totalProblems}
      </div>
      <button
        className="w-full flex items-center justify-between font-bold text-2xl px-4 py-2 bg-blue-900 text-white rounded-md hover:bg-blue-800 transition"
        onClick={() => handleAdd()}
      >
        Add Platform
        <IoIosAddCircleOutline className="text-3xl" />
      </button>

      {/* Popup Form */}
      {isPopupOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg w-[90%] sm:w-[50%] max-h-[85vh] overflow-auto scrollbar-hide
            [&::-webkit-scrollbar]:[width:10px]
            [&::-webkit-scrollbar-thumb]:bg-transparent
            [&::-webkit-scrollbar-thumb]:[border-radius:10px]
            overflow-x-hidden ">
            <div className="flex items-center justify-between px-6 py-2">
              <div className="text-xl font-bold text-blue-900">
                {editingIndex !== null ? "Edit Platform" : "Add Platform"}
              </div>
              <button onClick={togglePopup} className="text-2xl text-blue-900 bg-transparent">
                &times;
              </button>
            </div>
            <div className="px-6">
              <form onSubmit={handleAddOrEditPlatform}>
                <div className="mb-4">
                  <label className="block text-sm font-medium mb-1 text-left !text-gray-600">
                    Platform Name
                  </label>
                  <select
                    name="platformName"
                    value={form.platformName}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-2 border rounded-md"
                  >
                    <option value="">Select a Platform</option>
                    <option value="LeetCode">LeetCode</option>
                    <option value="GeeksForGeeks">GeeksForGeeks</option>
                    <option value="HackerRank">HackerRank</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                {form.platformName === "Other" && (
                  <div className="mb-4">
                    <label className="block text-sm font-medium mb-1 text-left !text-gray-700">
                      Custom Platform Name
                    </label>
                    <input
                      type="text"
                      name="customPlatformName"
                      value={form.customPlatformName}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-2 border rounded-md"
                      placeholder="Enter platform name"
                    />
                  </div>
                )}

                <div className="mb-4">
                  <label className="block text-sm font-medium mb-1 text-left !text-gray-700">
                    Profile Link
                  </label>
                  <input
                    type="url"
                    name="platformUserId"
                    value={form.platformUserId}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-2 border rounded-md"
                    placeholder="e.g., https://leetcode.com/john_doe/"
                  />
                </div>

                {(form.platformName === "LeetCode" ||
                  form.platformName === "GeeksForGeeks") && (
                    <div className="flex flex-row justify-between">
                      <div className="mb-4 pr-2">
                        <label className="block text-sm font-medium mb-1 text-left !text-gray-700">
                          Easy
                        </label>
                        <input
                          type="number"
                          name="easy"
                          value={form.easy}
                          onChange={handleInputChange}
                          required
                          className="w-full px-4 py-2 border rounded-md"
                          placeholder="e.g., 50"
                        />
                      </div>
                      <div className="mb-4 pr-2">
                        <label className="block text-sm font-medium mb-1 text-left !text-gray-700">
                          Medium
                        </label>
                        <input
                          type="number"
                          name="medium"
                          value={form.medium}
                          onChange={handleInputChange}
                          required
                          className="w-full px-4 py-2 border rounded-md"
                          placeholder="e.g., 30"
                        />
                      </div>
                      <div className="mb-4">
                        <label className="block text-sm font-medium mb-1 text-left !text-gray-700">
                          Hard
                        </label>
                        <input
                          type="number"
                          name="hard"
                          value={form.hard}
                          onChange={handleInputChange}
                          required
                          className="w-full px-4 py-2 border rounded-md"
                          placeholder="e.g., 20"
                        />
                      </div>
                    </div>
                  )}

                {(form.platformName === "HackerRank" ||
                  form.platformName === "Other") && (
                    <div className="mb-4">
                      <label className="block text-sm font-medium mb-1 text-left !text-gray-700">
                        Problems Solved
                      </label>
                      <input
                        type="number"
                        name="problemsSolved"
                        value={form.problemsSolved}
                        onChange={handleInputChange}
                        required
                        className="w-full px-4 py-2 border rounded-md"
                        placeholder="e.g., 150"
                      />
                    </div>
                  )}
                {error && editingIndex == null && (
                  <div className="text-red-600 text-center mb-4">
                    <strong>{error}</strong>
                  </div>
                )}

                <button
                  type="submit"
                  className="w-full bg-blue-900 text-white py-2 mb-2 rounded-md hover:bg-blue-800"
                >
                  {editingIndex !== null ? "Update Platform" : "Add Platform"}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Platforms List */}
      <div className="mt-6">
        {platformsList.length === 0 ? (
          <p className="text-center text-gray-600">No platforms added yet.</p>
        ) : (
          <ul className="space-y-2">
            {platformsList.map((platform, index) => (
              <li key={index} className="p-3 bg-white border border-gray-200 rounded-md">
                <div className="flex flex-row space-x-4 items-center justify-between">
                   <div className="w-1/3">
                    <div className="text-xl font-semibold text-left">
                      {platform.platformName}
                    </div>
                    <div className="text-sm text-gray-700 text-left">
                      Last edited Date: <b>{platform.lastEdited?.split('T')[0]}</b>
                    </div>
                    <div className="text-sm text-gray-700 text-left">
                      Profile Link:{" "}
                      <a
                        href={platform.platformUserId}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 underline"
                      >
                        {platform.platformUserId}
                      </a>
                    </div>

                  </div>
                  <div>
                    <div className="text-md text-gray-700 text-left">
                      Total Problems Solved: <b>{platform.problemsSolved}</b>
                    </div>
                    {/* <button
                      onClick={() => handleDeletePlatform(platform.id)}
                      className="text-red-600 hover:text-red-800"
                    >
                      Delete
                    </button> */}
                  </div>
                  <button
                    onClick={() => handleEdit(index)}
                    className="text-xl text-black bg-transparent"
                  >
                    <IoMdCreate />
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default CodingPlatform;